import React from "react";
import { useQuery } from "react-query";

import { fetchSAVByFoussierFournisseurs } from 'utils/queries';


import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import SkeletonTable from 'components/Shared/SkeletonTable';


const FournisseursResume = () => {


    const fournisseursQuery = useQuery(["SAVByFoussierFournisseurs"], fetchSAVByFoussierFournisseurs);


    


    if (fournisseursQuery.isLoading) {

        let headers = ["Fournisseur", "Marques", "Condition sous-garantie", "Condition hors-garantie"];

        return (
            <SkeletonTable headers={headers} />
        );
    }


    if (fournisseursQuery.error) {
        return (<p>Erreur du chargement des fournisseurs SAV by Foussier, veuillez contacter le support.</p>);
    }


    if (!fournisseursQuery.data) {
        return null;
    }


    return (
        <Table size='small'>
            <TableHead sx={{ backgroundColor: 'background.default' }}>
                <TableRow>
                    <TableCell>Fournisseur</TableCell>
                    <TableCell>Marques</TableCell>
                    <TableCell>Condition sous-garantie</TableCell>
                    <TableCell>Condition hors-garantie</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <>
                    {
                        fournisseursQuery.data.map((fournisseur, index) => {


                            return (
                                <TableRow hover  key={index}>

                                    <TableCell>
                                        {fournisseur.code} - {fournisseur.nom}
                                    </TableCell>
                                    <TableCell>
                                        {fournisseur.marques.map((marque, i) => {
                                            return (
                                                <span key={i}>
                                                    {marque.nom}<br/>
                                                </span>
                                            );
                                        })}


                                        {!fournisseur.marques.length && (
                                            <CancelIcon color="error" />
                                        )}

                                    </TableCell>
                                    <TableCell>
                                        {fournisseur.conditionSousGarantieApresUtilisation && (
                                            <CheckCircleIcon color="success" />
                                        )}
                                        {!fournisseur.conditionSousGarantieApresUtilisation && (
                                            <CancelIcon color="error" />
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {fournisseur.conditionHorsGarantie && (
                                            <CheckCircleIcon color="success" />
                                        )}
                                        {!fournisseur.conditionHorsGarantie && (
                                            <CancelIcon color="error" />
                                        )}
                                    </TableCell>

                                </TableRow>
                            );
                        })
                    }


                </>
            </TableBody>
        </Table>
    );

}




//const mapDispatchToProps = {
//    postSAVFournisseurClient,
//    deleteSAVFournisseurClient
//};

export default FournisseursResume;